import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput, DropdownInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const Overrides = (props: {rowData: [], field: string, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData"));

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    _.set(nextData, field, val)
    if (field === 'overridetype' && val === 'None'){
      const fields = ['overriderent', 'overrideti', 'overridelc', 'overrideoc', 'overriderenewalprob', 'overridedowntime']
      for (let i of fields){
        _.set(nextData, i, null)
      }
    }
    setData(nextData);
    props.persist(val, field, nextData)
  }

  const attrs = (field) => field_attrs('rentroll')(field)(props.rowData, props)

  const disabled = !data?.['overridetype'] || data['overridetype']  === 'None'
  const disabledText = "N/A"

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Override Type</label>
          <DropdownInput
            field="overridetype"
            className="automated"
            data={data}
            attrs={attrs}
            options={['None', 'First Term', 'All Terms']}
            persist={updateData}
          />
        </div>
        <div>
          <label>Rent</label>
          <NumberInput
            field="overriderent"
            className="automated billion-input"
            data={data}
            disabled={disabled}
            disabledText={disabledText}
            attrs={attrs}
            min={0}
            max={2000000000000}
            readPrecision={4}
            writePrecision={4}
            trailingZeros={false}
            persist={updateData}/>
        </div>
        <div>
          <label>T.I.</label>
          <NumberInput
            field="overrideti"
            className="automated billion-input"
            data={data}
            disabled={disabled}
            disabledText={disabledText}
            attrs={attrs}
            min={0}
            max={2000000000000}
            readPrecision={4}
            writePrecision={4}
            trailingZeros={false}
            persist={updateData}/>
        </div>
        <div>
          <label>L.C.</label>
          <NumberInput
            field="overridelc"
            className="automated billion-input"
            data={data}
            disabled={disabled}
            disabledText={disabledText}
            attrs={attrs}
            min={0}
            max={2000000000000}
            readPrecision={4}
            writePrecision={4}
            trailingZeros={false}
            persist={updateData}/>
        </div>
        <div>
          <label>O.C.</label>
          <NumberInput
            field="overrideoc"
            className="automated billion-input"
            data={data}
            disabled={disabled}
            disabledText={disabledText}
            attrs={attrs}
            min={0}
            max={2000000000000}
            readPrecision={4}
            writePrecision={4}
            trailingZeros={false}
            persist={updateData}/>
        </div>
        <div>
          <label>Renewal Prob</label>
          <NumberInput
            field="overriderenewalprob"
            className="automated billion-input"
            data={data}
            disabled={disabled}
            disabledText={disabledText}
            attrs={attrs}
            min={0}
            max={100}
            readPrecision={4}
            writePrecision={4}
            trailingZeros={false}
            persist={updateData}/>
        </div>
        <div>
          <label>Downtime</label>
          <NumberInput
            field="overridedowntime"
            className="automated billion-input"
            data={data}
            disabled={disabled}
            disabledText={disabledText}
            attrs={attrs}
            min={0}
            max={1200}
            readPrecision={0}
            writePrecision={0}
            trailingZeros={false}
            persist={updateData}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Overrides
